// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common styles for initials and machine */
.initialsCircle_initials__PDPPl,
.initialsCircle_initials__square__r7Bh8 {
  display: flex;
  padding: 1px 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 1px solid #474949;
  transition: background 0.3s, color 0.3s, border 0.3s;
}

.initialsCircle_initials__PDPPl {
  border-radius: 10px;
}

.initialsCircle_initials__square__r7Bh8 {
  border-radius: 1px;
}

/* Complete styles */
.initialsCircle_complete__bUFGv {
  color: white;
  border: 1px solid white;
}

.initialsCircle_complete__bUFGv .initialsCircle_initails__typography__6avp8 {
  color: white;
}

/* Hover styles */
.initialsCircle_initials__PDPPl:hover,
.initialsCircle_initials__square__r7Bh8:hover {
  background: #075e5b;
  border: 1px solid #075e5b;
}

.initialsCircle_initials__PDPPl:hover .initialsCircle_initails__typography__6avp8,
.initialsCircle_initials__square__r7Bh8:hover .initialsCircle_initails__typography__6avp8 {
  color: #fff;
}

/* Typography styles */
.initialsCircle_initails__typography__6avp8 {
  color: #474949;
  font-family: Gadugi;
  font-size: 0.8em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

/* New hover styles */
.initialsCircle_hoverRed__q\\+6wM:hover {
  background: #e12c4f;
  border: 1px solid #e12c4f;
}

.initialsCircle_hoverRed__q\\+6wM:hover .initialsCircle_initails__typography__6avp8 {
  color: white;
}

.initialsCircle_hoverGreen__4Z-kX:hover {
  background: #075e5b;
  border: 1px solid #075e5b;
}

.initialsCircle_hoverGreen__4Z-kX:hover .initialsCircle_initails__typography__6avp8 {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/InitalsCircle/initialsCircle.module.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Common styles for initials and machine */\n.initials,\n.initials__square {\n  display: flex;\n  padding: 1px 6px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #474949;\n  transition: background 0.3s, color 0.3s, border 0.3s;\n}\n\n.initials {\n  border-radius: 10px;\n}\n\n.initials__square {\n  border-radius: 1px;\n}\n\n/* Complete styles */\n.complete {\n  color: white;\n  border: 1px solid white;\n}\n\n.complete .initails__typography {\n  color: white;\n}\n\n/* Hover styles */\n.initials:hover,\n.initials__square:hover {\n  background: #075e5b;\n  border: 1px solid #075e5b;\n}\n\n.initials:hover .initails__typography,\n.initials__square:hover .initails__typography {\n  color: #fff;\n}\n\n/* Typography styles */\n.initails__typography {\n  color: #474949;\n  font-family: Gadugi;\n  font-size: 0.8em;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n/* New hover styles */\n.hoverRed:hover {\n  background: #e12c4f;\n  border: 1px solid #e12c4f;\n}\n\n.hoverRed:hover .initails__typography {\n  color: white;\n}\n\n.hoverGreen:hover {\n  background: #075e5b;\n  border: 1px solid #075e5b;\n}\n\n.hoverGreen:hover .initails__typography {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"initials": `initialsCircle_initials__PDPPl`,
	"initials__square": `initialsCircle_initials__square__r7Bh8`,
	"complete": `initialsCircle_complete__bUFGv`,
	"initails__typography": `initialsCircle_initails__typography__6avp8`,
	"hoverRed": `initialsCircle_hoverRed__q+6wM`,
	"hoverGreen": `initialsCircle_hoverGreen__4Z-kX`
};
export default ___CSS_LOADER_EXPORT___;
